/*
  Scroll reveal for product cards in grids marked with `.after-reveal`.
  Each card rises from the bottom and fades in as it enters the viewport.
  Dynamically added cards (e.g. recently-viewed) are picked up via a
  MutationObserver. Falls back to showing everything if unsupported.
*/
(function () {
  var root = document.documentElement;

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('reveal-ready');
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function observeWithin(node) {
    if (!node || !node.querySelectorAll) return;
    node
      .querySelectorAll('.after-reveal .after-product-card:not(.is-in)')
      .forEach(function (card) {
        io.observe(card);
      });
  }

  function start() {
    observeWithin(document);

    // Catch cards inserted later (recently viewed, AJAX, etc.).
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (added) {
          if (added.nodeType !== 1) return;
          if (added.matches && added.matches('.after-reveal .after-product-card')) {
            io.observe(added);
          } else {
            observeWithin(added);
          }
        });
      });
    });

    document.querySelectorAll('.after-reveal').forEach(function (grid) {
      mo.observe(grid, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
